<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage" id="sec-5">
<h1 class="title" id="pAkY" style="margin-bottom: 3em;">
					FINDING THEIR VOICES<br/><span class="small">SERMONS BY WOMEN IN THE CHURCHES OF CHRIST</span></h1>
<h2 class="author" id="pz5-2" style="margin-bottom: 5em;">
					D’ESTA LOVE </h2>
<div class="image" id="pz5-3">
<img alt="images/himg-5-1.png" id="z5-3" src="images/himg-5-1.png"/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?0f5e622b